export default [
  {
    path: '/couponCategory',
    component: () => import('../pages/coupon/couponCategory.vue'),
    name: 'couponCategory',
    title: '优惠券类型',
    meta: {
      title: '优惠券类型',
    },
  },
  {
    path: '/couponManage',
    component: () => import('../pages/coupon/couponManage.vue'),
    name: 'couponManage',
    title: '优惠券管理',
    meta: {
      title: '优惠券管理',
    },
  },
  {
    path: '/newCouponManage',
    component: () => import('../pages/coupon/newCouponManage.vue'),
    name: 'newCouponManage',
    title: '优惠券管理(新)',
    meta: {
      title: '优惠券管理(新)',
    },
  },
  {
    path: '/buyRecord',
    component: () => import('../pages/coupon/buyRecord.vue'),
    name: 'buyRecord',
    title: '购买记录',
    meta: {
      title: '购买记录',
    },
  },
  {
    path: '/exchangeRecord',
    component: () => import('../pages/coupon/exchangeRecord.vue'),
    name: 'exchangeRecord',
    title: '核销记录',
    meta: {
      title: '核销记录',
    },
  },
  {
    path: '/shareRecord',
    component: () => import('../pages/coupon/shareRecord.vue'),
    name: 'shareRecord',
    title: '分享记录',
    meta: {
      title: '分享记录',
    },
  },
  {
    path: '/couponOrderManage',
    component: () => import('../pages/coupon/couponOrderManage.vue'),
    name: 'couponOrderManage',
    title: '分享订单管理',
    meta: {
      title: '分享订单管理',
    },
  },
]
